"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _default = typeof window !== 'undefined' ? window.atob.bind(window) : function (str) {
  return Buffer.from(str, 'base64').toString('utf8');
};

exports["default"] = _default;